import { faFacebookF } from "@fortawesome/free-brands-svg-icons/faFacebookF"
import { faFacebookMessenger } from "@fortawesome/free-brands-svg-icons/faFacebookMessenger"
import { faPinterest } from "@fortawesome/free-brands-svg-icons/faPinterest"
import { faXTwitter } from "@fortawesome/free-brands-svg-icons/faXTwitter"
import { faShareAlt } from "@jewlr/pro-solid-svg-icons/faShareAlt"
import PropTypes from "prop-types"
import { useEffect, useState } from "react"

import Button from "components/ui/button"
import FontAwesomeIcon from "components/ui/font-awesome-icon"
import socialShare from "helpers/social-share"
import WebShareApi from "helpers/web-share-api"

const ShareArticle = ({ article }) => {
  const [nativeShare, setNativeShare] = useState(true)

  useEffect(() => {
    if (!WebShareApi.shareIsSupported()) {
      setNativeShare(false)
    }
  }, [])

  const doSocialShare = (share_type, e) => {
    let popup = null
    if (share_type === "Twitter" || share_type === "Pinterest") {
      popup = window.open("", "_blank", "status=1,width=650,height=550")
    }
    e.preventDefault()

    const share_properties = {
      clickLabel: article.title,
      clickType: `Article ${share_type} Share`,
      imageUrl: "https://assets.jewlr.com/images/logos/jewlr-logo.svg",
      message: `Check this out from Jewlr! ${article.title}`,
      popup,
      url: window.location.href,
    }

    socialShare({ share_type, ...share_properties })
  }

  const doNativeShare = (e) => {
    e.preventDefault()
    WebShareApi.triggerWebShare(
      "Jewlr",
      `Check this out from Jewlr! ${article.title}`,
      window.location.href,
      (err) => {
        if (err) {
          console.log(err)
        }
      }
    )
  }

  return (
    <div className="tablet:mb-40 tablet:mt-72 mb-16 mt-56 flex flex-col items-center">
      {nativeShare ? (
        <Button
          className="border-black-print mb-20 border"
          onClick={(e) => doNativeShare(e)}
          variant="tertiary"
        >
          Share This Article
          <FontAwesomeIcon className="text-18 ml-8" icon={faShareAlt} />
        </Button>
      ) : (
        <>
          <h4 className="text-16 leading-20 mb-20 font-medium">
            Share This Article
          </h4>
          <div className="gap-18 flex items-center text-black">
            <Button
              aria-label="Share this article via Facebook"
              onClick={(e) => doSocialShare("Facebook", e)}
            >
              <FontAwesomeIcon className="text-18" icon={faFacebookF} />
            </Button>
            <Button
              aria-label="Share this article via X"
              onClick={(e) => doSocialShare("Twitter", e)}
            >
              <FontAwesomeIcon className="text-18" icon={faXTwitter} />
            </Button>
            <Button
              aria-label="Share this article via Pinterest"
              onClick={(e) => doSocialShare("Pinterest", e)}
            >
              <FontAwesomeIcon className="text-18" icon={faPinterest} />
            </Button>
            <Button
              aria-label="Share this article via Messenger"
              onClick={(e) => doSocialShare("Messenger", e)}
            >
              <FontAwesomeIcon className="text-18" icon={faFacebookMessenger} />
            </Button>
          </div>
        </>
      )}
    </div>
  )
}

ShareArticle.propTypes = {
  article: PropTypes.object,
}

export default ShareArticle
